import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { auth } from '../../../../../services';
import { Row, Col } from 'reactstrap';
import './AccountPreference.scss';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';
import { getPreference, savePreference } from '../../../../../Redux/Actions/EndUser/AccountPreferenceActions';

class AccountPreference extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            newsletters: []
        }
    }

    componentDidMount() {
        this.props.getPreference(auth.getAuthUserId());
    }

    

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.newsletters !== this.props.newsletters){
          this.setState({newsletters: this.props.newsletters});
        }
    }

    handleChange = (event) => {
        const target = event.target;
        var id = target.id.toString();
        var arr = this.state.newsletters.map(item => {
            return {
                id: item.id,
                title: item.title,
                selected: item.id.toString() === id ? target.checked : item.selected
            }
        })
        this.setState({newsletters: arr});
    }

    update = (event) => {
        if (auth.isAuthenticated()) {
            var userId = auth.getAuthUserId()
            this.props.savePreference(this.state.newsletters, userId)
        }
        event.preventDefault();
    }

  render() {
      if (this.props.getting)
        return ( <IsLoading /> )
    return (
        <div>
            <div className="account-tab-content account-preferences">
                <div>
                    <h1 className="pt-3 pb-3 header-long">Account Preferences</h1>
                    <h3 className="account-tab-content-right">Newsletter Subscription</h3>
                </div>
                <div className="edit-account-form card">
                    {/* <Col xs="12" sm="6" md="4"> */}
                    <div className="card newsletter-card">
                        <ul className="list-group list-group-flush">
                        {
                            this.state.newsletters.map((item, index) => 
                                <li className="list-group-item" key={index}>
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" 
                                        className="custom-control-input" 
                                        id={item.id} 
                                        checked = {item.selected}
                                        value={item.selected}
                                        onChange={this.handleChange} />
                                        <label className="custom-control-label" htmlFor={item.id}>{item.title}</label>
                                    </div>
                                </li>
                            )
                        }
                        </ul>
                    
                    <div className="list-group-item">
                        <Button 
                        color="primary" 
                        className="btnPrimary" 
                        onClick={this.update}>
                        {
                            this.props.updating
                            ? <SpanSpinner message="Updating ..." />
                            : <span>UPDATE</span>
                        }
                        
                        </Button>
                    </div>
                    </div>
                    {/* </Col> */}
                </div>
                <div className="clearfix"></div>              
            </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        error: state.preference.error,
        updating: state.preference.updating,
        getting: state.preference.getting,
        newsletters: state.preference.newsletters,
        email: state.preference.email
    };
}

export default connect(mapStateToProps, {
    getPreference,
    savePreference
})(AccountPreference);